import { useCountrySection } from '@/hooks/useCountrySection';
import { useRouteSection } from '@/hooks/useRouteSection';
import { devices } from '@/theme/device';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Footer = () => {
  const { t } = useTranslation();
  const routeSection = useRouteSection();
  const countrySection = useCountrySection();

  return (
    <Wrapper>
      <Text>{t(`form.footer.${routeSection}.${countrySection}`)}</Text>
      <Text>{t(`form.footer.licensed.${countrySection}`)}</Text>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.footer`
  color: #b0afaf;
  text-align: center;
  padding: 3rem 1.5rem;
  border-bottom: 2px solid #ffbf00;
`;

const Text = styled.p`
  margin: 0;
  font-family: ${(props) => props.theme.fontFamily};
  font-weight: 500;
  @media only screen and ${devices.xs} {
    font-size: 0.7rem;
  }
  @media only screen and ${devices.md} {
    font-size: 1rem;
  }
`;
